import Vue from 'vue';
export default Vue.extend({
    name: 'GlobalCommbookAttachmentStrip',
    props: {
        files: { type: Array, required: true },
        uploads: { type: Array, default: function () { return []; } },
        disabled: { type: Boolean, default: false }
    },
    methods: {
        isImage: function (file) {
            return /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(file.fileName);
        },
        formatSize: function (size) {
            if (size >= 1024 * 1024)
                return "".concat((size / (1024 * 1024)).toFixed(1), "MB");
            return "".concat((size / 1024).toFixed(1), "KB");
        }
    }
});
